export enum PreBookingStatus {
  CONFIRMED = "Confirmed",
  PENDING = "Pending",
  CANCELLED = "Cancelled",
}
